module.exports = __webpack_public_path__ + "img/77400.15889c86.jpg";